<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="ngModel | tituloReceberSituacao | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull">Nenhuma situação</option>
        <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome | uppercase}}</option>
    </select>  
</ng-template>